<template>
  <div class="container">
    <h4 class="title is-4">Flags</h4>
    <b-table
        :narrowed="true"
        :striped="true"
        :data="tableData"
    >
      <template slot-scope="props">
        <b-table-column label="#" field="num" numeric>
          {{props.row.num}}
        </b-table-column>
        <b-table-column label="Flag" field="flag">
          {{props.row.flag}}
        </b-table-column>
        <b-table-column label="Value" field="value" numeric>
          {{props.row.value}}
        </b-table-column>
      </template>
    </b-table>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import BTable from "buefy/src/components/table/Table";
  import BTableColumn from "buefy/src/components/table/TableColumn";

  export default {
    components: {
      BTableColumn,
      BTable },
    name: "screenflags",
    data() {
      return {};
    },
    computed: {
      ...mapGetters('auth', ['flags']),
      tableData() {
        if (!this.flags) {
          return [];
        }

        let num = 0;
        return this.flags.map(item => {
          num++;
          return {
            ...item,
            num
          };
        });
      }
    }
  }
</script>

<style scoped>

</style>